var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { merge, Subject } from 'rxjs';
import { debounceTime, switchMap, throttleTime } from 'rxjs/operators';
import { CancelledRequest, HttpExecutorConfigController } from '../Shared/HttpRequestExecutor';
var AsyncFetch = /** @class */ (function (_super) {
    __extends(AsyncFetch, _super);
    function AsyncFetch(props) {
        var _this = _super.call(this, props) || this;
        _this.submission$$ = null;
        _this.activateSubmitting$$ = null;
        _this.httpConfig = new HttpExecutorConfigController();
        _this.refresh = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.submission$.next(args);
                    return [2 /*return*/];
                });
            });
        };
        _this.reset = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setState({ data: this.props.defaultValue ? this.props.defaultValue : null });
                return [2 /*return*/];
            });
        }); };
        _this.updateData = function (data) {
            _this.setState({ data: data });
        };
        _this.submission$ = new Subject();
        _this.debouncedSubmission$ = new Subject();
        _this.state = {
            loading: false,
            loadingErrors: '',
            data: _this.props.defaultValue ? _this.props.defaultValue : null,
            refresh: _this.refresh,
            reset: _this.reset,
            updateData: _this.updateData,
            loadCount: 0
        };
        return _this;
    }
    AsyncFetch.prototype.componentDidMount = function () {
        var _this = this;
        this.activateSubmitting$$ = merge(this.submission$, this.debouncedSubmission$).subscribe(function () {
            _this.setState({
                loading: true
            });
        });
        this.submission$$ = merge(this.submission$.pipe(throttleTime(500)), this.debouncedSubmission$.pipe(debounceTime(500)))
            .pipe(switchMap(function (args) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                if (!!args)
                    return [2 /*return*/, (_a = this.props).fetch.apply(_a, __spreadArray([this.httpConfig], __read(args), false))];
                return [2 /*return*/, this.props.fetch(this.httpConfig)];
            });
        }); }))
            .subscribe(function (data) {
            if (data instanceof CancelledRequest)
                return;
            _this.setState(function (prevState) { return ({
                loading: false,
                data: data,
                loadingErrors: '',
                loadCount: ++prevState.loadCount
            }); });
        }, function (err) {
            _this.setState(function () {
                throw err;
            });
        });
        if (!this.props.preventInitialLoad)
            this.submission$.next();
    };
    AsyncFetch.prototype.componentWillUnmount = function () {
        if (this.httpConfig) {
            this.httpConfig.cleanUp();
        }
        if (this.submission$$ && this.submission$$.unsubscribe)
            this.submission$$.unsubscribe();
        if (this.activateSubmitting$$ && this.activateSubmitting$$.unsubscribe)
            this.activateSubmitting$$.unsubscribe();
    };
    AsyncFetch.prototype.render = function () {
        if (this.state.loadingErrors && this.props.renderError)
            return this.props.renderError(this.state);
        return this.props.render(this.state);
    };
    return AsyncFetch;
}(React.Component));
export { AsyncFetch };
